export const color = {
  textColor: "#424242"
}
